import React, {useEffect} from "react";
import "./App.css";
import Main from "./containers/Main";

function App() {
  useEffect(() => {
    document.title = "Rizwan Shaikh";
  }, []);
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
